<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          // icon: 'mdi-needle',
          title: 'Corona-proof',
          text: 'Wij zijn niet verantwoordelijk voor jou. Laat dat duidelijk zijn. Wij verzorgen enkel het programma.',
        },
        {
          // icon: 'mdi-web',
          title: 'Decentraal',
          text: 'We draaien alles om, jij komt niet naar een vieze stinkende camping. Nee, de vetste acts komen op een nieuwe manier naar je toe.',
        },
        {
          // icon: 'mdi-speaker',
          title: 'Jouw soundsystem',
          text: 'Headphones, radio, flatscreen of speakers doen het allemaal op ons programma op 13 juni.',
        },
        {
          // icon: 'mdi-book-open-page-variant',
          title: 'Interactief programma',
          text: 'Dit blijft nog even geheim',
        },
        {
          // icon: 'mdi-clipboard-alert-outline',
          title: 'Beste line up',
          text: 'Wat dacht je van een zieke line up, terwijl we allemaal intussen ziek zijn van het nieuws. ',
        },
        {
          // icon: 'mdi-account-group',
          title: 'Samen dansen',
          text: 'Doe de pas, maar wel gepast, in de pas van 1,5 meter. Pas wel op en ga uit je dak. Gewoon, danspasjes.',
        },
        {
          // icon: 'mdi-package-variant',
          title: 'Festivaldoosje',
          text: 'Met het festivalgevoel uit een doosje zorgen we ervoor dat iedereen voor lul staat. Zelfspot is het beste als we het met zijn allen doen.',
        },
        {
          // icon: 'mdi-heart',
          title: 'Festival gevoel',
          text: 'Was 2019 echt de laatste keer dat we dat voelde? Moeten we niet gewoon iets proberen in 2020?',
        },
      ],
    }),
  }
</script>
